import React from "react";
import UserSection from "./components/UserSection";
import BookSection from "./components/BookSection";

function App() {
  return (
    <div style={{ maxWidth: 900, margin: "0 auto", fontFamily: "Arial, sans-serif" }}>
      <h1 style={{ textAlign: "center" }}>📚 Library Management</h1>
      <UserSection />
      <BookSection />
    </div>
  );
}

export default App;
